class TyCardGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ty-track]');
    if (!this.track) return;

    this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });
    this.updateDots();
  }

  updateDots() {
    const width = this.track.clientWidth;
    if (!width) return;

    const index = Math.round(this.track.scrollLeft / width);
    this.querySelectorAll('[data-ty-dot]').forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  }
}

if (!customElements.get('ty-card-gallery')) {
  customElements.define('ty-card-gallery', TyCardGallery);
}
